import { ROLE } from 'constant/role';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import ClassOutlinedIcon from '@mui/icons-material/ClassOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import SyncAltOutlinedIcon from '@mui/icons-material/SyncAltOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import QrCode2OutlinedIcon from '@mui/icons-material/QrCode2Outlined';

const filterChildren = (children: any[], disabledPaths: string[]) => {
  return children.filter(child => !disabledPaths.includes(child.path));
};

export const getNavigationCategory = (role: string, disabledPaths: string[] = []) => {
  switch (role) {
    case ROLE.ADMIN:
      return [
        {
          id: 'Quản trị hệ thống',
          children: filterChildren([
            {
              id: 'Cấu hình Menu',
              icon: <SettingsOutlinedIcon />,
              path: 'menu-config',
            },
          ], disabledPaths),
        },
        {
          id: 'Quản trị tài khoản',
          children: filterChildren([
            {
              id: 'Thêm tài khoản',
              icon: <PersonAddAltOutlinedIcon />,
              path: 'add-account',
            },
            {
              id: 'Danh sách tài khoản',
              icon: <ManageAccountsOutlinedIcon />,
              path: 'account-list',
            },
          ], disabledPaths),
        },
        {
          id: 'Báo cáo - Thống kê',
          children: filterChildren([
            {
              id: 'Trung tâm Báo cáo',
              icon: <AssessmentOutlinedIcon />,
              path: 'reports',
            },
          ], disabledPaths),
        },
        {
          id: 'Quản trị lớp học',
          children: filterChildren([
            {
              id: 'Danh sách lớp học',
              icon: <ClassOutlinedIcon />,
              path: 'class-list',
            },
            {
              id: 'Danh sách lớp học theo năm',
              icon: <SchoolOutlinedIcon />,
              path: 'class-year-list',
            },
            {
              id: 'Danh sách học sinh',
              icon: <GroupsOutlinedIcon />,
              path: 'student-list',
            },
          ], disabledPaths),
        },
      ];

    case ROLE.ACCOUNTANT:
      return [
        {
          id: 'Cấu hình',
          children: filterChildren([
            {
              id: 'Cấu hình tháng làm việc',
              icon: <CalendarMonthOutlinedIcon />,
              path: 'work-month',
            },
            {
              id: 'Cấu hình hóa đơn',
              icon: <DescriptionOutlinedIcon />,
              path: 'invoice-config',
            },
            {
              id: 'Cấu hình lớp học',
              icon: <ClassOutlinedIcon />,
              path: 'class-list',
            },
            {
              id: 'Cấu hình nguồn thu',
              icon: <MonetizationOnOutlinedIcon />,
              path: 'revenue-sources',
            },
            {
              id: 'Cấu hình khối thu',
              icon: <CategoryOutlinedIcon />,
              path: 'revenue-blocks',
            },
          ], disabledPaths),
        },
        {
          id: 'Quản trị biên lai',
          children: filterChildren([
            {
              id: 'Đăng ký nhanh',
              icon: <BoltOutlinedIcon />,
              path: 'quick-register',
            },
            {
              id: 'DS NT theo lớp',
              icon: <RequestQuoteOutlinedIcon />,
              path: 'class-year-income',
            },
            {
              id: 'Thêm biên lai',
              icon: <PostAddOutlinedIcon />,
              path: 'add-bill',
            },
            {
              id: 'Danh sách chờ duyệt',
              icon: <FactCheckOutlinedIcon />,
              path: 'pending-approval-bill-list',
            },
            {
              id: 'Danh sách biên lai',
              icon: <ReceiptLongOutlinedIcon />,
              path: 'bill-list',
            },
            {
              id: 'Gộp & Xuất QR học phí',
              icon: <QrCode2OutlinedIcon />,
              path: 'qr-payment-slip',
            },
            {
              id: 'Lịch sử hóa đơn',
              icon: <HistoryOutlinedIcon />,
              path: 'invoice-history',
            },
            {
              id: 'Theo dõi thu nộp',
              icon: <AssessmentOutlinedIcon />,
              path: 'class-payment-statistics',
            },
          ], disabledPaths),
        },
        {
          id: 'Quản lý chấm ngày',
          children: filterChildren([
            {
              id: 'Chấm ngày',
              icon: <EventAvailableOutlinedIcon />,
              path: 'class-month-attendance',
            },
            {
              id: 'Chốt thực tế',
              icon: <TaskAltOutlinedIcon />,
              path: 'class-actual-settle',
            },
            {
              id: 'Kết chuyển số dư',
              icon: <SyncAltOutlinedIcon />,
              path: 'class-settle-carry-forward',
            },
          ], disabledPaths),
        },
        {
          id: 'Báo cáo - Thống kê',
          children: filterChildren([
            {
              id: 'Trung tâm Báo cáo',
              icon: <AssessmentOutlinedIcon />,
              path: 'reports',
            },
          ], disabledPaths),
        },
        {
          id: 'Quản trị lớp học',
          children: filterChildren([
            {
              id: 'Danh sách lớp học',
              icon: <SchoolOutlinedIcon />,
              path: 'class-year-list',
            },
            {
              id: 'Danh sách học sinh',
              icon: <GroupsOutlinedIcon />,
              path: 'student-list',
            },
          ], disabledPaths),
        },
      ];

    case ROLE.TEACHER:
      return [
        {
          id: 'Quản trị lớp chủ nhiệm',
          children: filterChildren([
            {
              id: 'Danh sách lớp chủ nhiệm',
              icon: <SchoolOutlinedIcon />,
              path: 'homeroom-classes',
            },
          ], disabledPaths),
        },
        {
          id: 'Quản trị lớp dạy',
          children: filterChildren([
            {
              id: 'Danh sách lớp dạy',
              icon: <ClassOutlinedIcon />,
              path: 'subject-class-list',
            },
          ], disabledPaths),
        },
      ];
    default:
      return [];
  }
};

export const getSidebarTitleByPath = (pathname: string, role?: string): string | undefined => {
  const cleanPath = pathname.replace(/^\/+|\/+$/g, '');
  if (!cleanPath) return 'Trang chủ';
  const currentRole = role || (localStorage.getItem('role') as string);
  const categories = getNavigationCategory(currentRole, []);
  for (const cat of categories) {
    const found = cat.children.find((item) => item.path === cleanPath);
    if (found) return found.id;
  }
  return undefined;
};
